/* Canine Keeps homepage: shared interactions across the ck-* sections. */
(function () {
  if (window.CKHome) { window.CKHome.init(); return; }
  var state = { name: '' };
  try { state.name = sessionStorage.getItem('ck_dog_name') || ''; } catch (e) {}
  var FALLBACK = 'Teddy';

  function poss(n) { return /s$/i.test(n) ? n + "'" : n + "'s"; }
  function all(sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); }

  function renderName() {
    var n = state.name.trim();
    all('.ckh .js-label').forEach(function (el) {
      var next = poss(n || el.getAttribute('data-sample') || FALLBACK);
      if (el.textContent !== next) {
        el.textContent = next;
        if (el.tagName === 'B') { el.classList.remove('swap'); void el.offsetWidth; el.classList.add('swap'); }
      }
    });
    all('.ckh .js-cta').forEach(function (el) {
      var tpl = n ? el.getAttribute('data-named') : el.getAttribute('data-default');
      if (tpl) el.textContent = tpl.replace('[name]', poss(n));
    });
    all('.ckh .js-object').forEach(function (el) {
      var t = n || el.getAttribute('data-default') || '';
      el.textContent = t;
      var dot = el.nextElementSibling;
      if (dot && dot.classList.contains('js-dot')) dot.hidden = !t;
    });
    all('.ckh .js-poss').forEach(function (el) { el.textContent = n ? poss(n) : (el.getAttribute('data-default') || ''); });
    all('.ckh .js-name').forEach(function (el) { if (el.value !== state.name && document.activeElement !== el) el.value = state.name; });
  }

  function selectedTags() {
    var seen = {}, out = [];
    all('.ckh [data-tag][aria-pressed="true"]').forEach(function (el) {
      var t = el.getAttribute('data-tag');
      if (!seen[t]) { seen[t] = 1; out.push(t); }
    });
    return out;
  }
  function renderTags() {
    var on = selectedTags();
    all('.ckh .js-tags').forEach(function (t) {
      t.innerHTML = '';
      on.forEach(function (x) { var s = document.createElement('span'); s.textContent = x; t.appendChild(s); });
    });
    all('.ckh .js-count').forEach(function (el) {
      var one = el.getAttribute('data-one') || 'priority', many = el.getAttribute('data-many') || 'priorities';
      el.textContent = on.length + ' ' + (on.length === 1 ? one : many);
    });
  }

  function openQuiz(fromEl) {
    var link = (fromEl && fromEl.getAttribute('data-quiz')) || '#';
    var a = document.createElement('a');
    a.href = link; a.style.display = 'none';
    document.body.appendChild(a); a.click();
    setTimeout(function () { a.remove(); }, 0);
  }

  function bind(root) {
    root.querySelectorAll('.js-name').forEach(function (inp) {
      if (inp.dataset.ckBound) return; inp.dataset.ckBound = '1';
      inp.value = state.name;
      inp.addEventListener('input', function () {
        state.name = inp.value;
        try { sessionStorage.setItem('ck_dog_name', state.name); } catch (e) {}
        renderName();
      });
    });
    root.querySelectorAll('form.js-namebar').forEach(function (f) {
      if (f.dataset.ckBound) return; f.dataset.ckBound = '1';
      f.addEventListener('submit', function (e) { e.preventDefault(); openQuiz(f); });
    });
    root.querySelectorAll('[data-tag]').forEach(function (btn) {
      if (btn.dataset.ckBound) return; btn.dataset.ckBound = '1';
      btn.addEventListener('click', function () {
        var tag = btn.getAttribute('data-tag');
        var next = btn.getAttribute('aria-pressed') !== 'true';
        all('.ckh [data-tag="' + tag + '"]').forEach(function (t) { t.setAttribute('aria-pressed', String(next)); });
        if (next) {
          var src = document.querySelector('.ckh .chip[data-tag="' + tag + '"]');
          all('.ckh .js-desc').forEach(function (d) { if (src) d.textContent = src.getAttribute('data-desc'); });
        }
        renderTags();
      });
    });
    root.querySelectorAll('.seg').forEach(function (seg) {
      if (seg.dataset.ckBound) return; seg.dataset.ckBound = '1';
      var btns = seg.querySelectorAll('button');
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          btns.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
          var scope = seg.closest('.ckh');
          var p = scope && scope.querySelector('.js-price');
          if (p) p.textContent = b.getAttribute('data-price');
          var u = scope && scope.querySelector('.js-unit');
          if (u) u.textContent = b.getAttribute('data-unit');
        });
      });
    });
  }

  function init() { bind(document); renderName(); renderTags(); }

  window.CKHome = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
